module.exports = __webpack_public_path__ + "img/extension2.117e0826.jpg";